import { BankOutlined, WalletOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { ACCOUNT_ROLE_CODES } from '@lib/types';
import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const AdminFinancePage = lazyRouteComponent(
  () => import('./pages/admin-dashboard'),
);

const FinancePage = lazyRouteComponent(() => import('./pages/overview'));
const AdminWithdrawalsPage = lazyRouteComponent(
  () => import('./pages/admin-withdrawals'),
);

export const getRoutes = (): Route[] => [
  {
    page: AdminFinancePage,
    path: ROUTE_PATHS.ADMIN_FINANCE,
    title: 'Financeiro',
    icon: WalletOutlined,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
    adminSection: 'finance',
    adminOrder: 10,
  },
  {
    page: FinancePage,
    path: ROUTE_PATHS.STORE_FINANCE,
    title: 'Minha carteira',
    icon: WalletOutlined,
    hidden: true,
  },
  {
    page: AdminWithdrawalsPage,
    path: ROUTE_PATHS.ADMIN_WITHDRAWALS,
    title: 'Saques',
    icon: BankOutlined,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
    adminSection: 'finance',
    adminOrder: 20,
  },
];
